export default function getEnv(variable) {
  if (process.env.REACT_APP_HEROKU_ENV === 'production') {
    return process.env[variable + '_PROD'];
  }
  return process.env[variable];
}



// WEBPACK FOOTER //
// ./src/helpers/getEnv.js